/* eslint-disable import/prefer-default-export */
export const SIGN_UP_MATS_REWARD = 300
